import classNames from 'classnames'
import React from 'react'

import Image from '../image/Image'
import Link from '../link'

import styles from './imageLink.module.scss'

export interface ImageLinkProps {
  imageTitle: string
  imageUrl: string
  linkText: string
  linkTo: string
  className?: string
}

const ImageLink = ({ imageTitle, imageUrl, linkTo, linkText, className }: ImageLinkProps) => {
  return (
    <div className={classNames(styles.imageLink, className)}>
      <Image url={imageUrl} title={imageTitle} />
      <Link href={linkTo}>{linkText}</Link>
    </div>
  )
}

export default ImageLink
